import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

// "Editar com IA" on a clip card: opens the clip in AI Studio. Icon-only, so
// the label is its accessible name and tooltip. Stops propagation because
// the cards toggle selection on click.
export function EditWithAiButton({ onClick, disabled, className }: Props) {
  const { t } = useTranslation();
  const label = t('aiAssistant.studio.editWithAi');
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('h-8 w-8 shrink-0 p-0', className)}
      disabled={disabled}
      aria-label={label}
      title={label}
      data-testid="clip-edit-with-ai"
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      <Sparkles className="h-3.5 w-3.5 text-primary" />
    </Button>
  );
}
